import React from "react";

const Info = () => {
  return (
    <div className="about__info grid">
      <div className="about__box">
        <i className="bx bx-briefcase-alt"></i>

        <h3 className="about__title">Projects</h3>
        <span className="about__subtitle">25+ Projects</span>
      </div>

      <div className="about__box">
        <i className="bx bx-award"></i>

        <h3 className="about__title">Education</h3>
        <span className="about__subtitle">
          Diploma in Data Science, IITM & B.Tech. in CSE (AI & ML), CVRGU
        </span>
      </div>

      <div className="about__box">
        <i className="bx bx-bulb"></i>
        <h3 className="about__title">Skills</h3>
        <span className="about__subtitle">
          Focused on data analytics, analysis, and machine learning.
        </span>
      </div>
    </div>
  );
};

export default Info;
